import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import { components as Core, translate, constants as coreConstants, getTableProps, getPagination, valueBuilder } from '../../../core';

export const COLUMNS = {
    date: 'date',
    action: 'action',
    message: 'message'
};

class IntegrationLogs extends React.PureComponent {
    static propTypes = {
        i18n: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
        companyId: PropTypes.string.isRequired,
        integrationId: PropTypes.string.isRequired,
        logs: PropTypes.array,
        isLoading: PropTypes.bool,
        pagination: PropTypes.object.isRequired
    };

    static defaultProps = {
        logs: [],
        isLoading: false
    };

    constructor(props) {
        super(props);
        const { i18n } = this.props;
        this.tableColumns = [{
            title: i18n.t("integrations.logs.date"),
            key: COLUMNS.date,
            dataIndex: COLUMNS.date,
            render: valueBuilder.getLocalFullTime,
            sorter: true,
            sortDirections: coreConstants.BOTH_SORT_DIRECTIONS
        }, {
            title: i18n.t("integrations.logs.action"),
            key: COLUMNS.action,
            dataIndex: COLUMNS.action,
            render: this.renderAction
        }, {
            title: i18n.t("integrations.logs.message"),
            key: COLUMNS.message,
            dataIndex: COLUMNS.message
        }];
        this.props.actions.getIntegrationLogs(this.props.companyId, this.props.integrationId);
    }

    onChangeTable = (pagination, filters, sorter) => {
        this.props.actions.getIntegrationLogs(
            this.props.companyId,
            this.props.integrationId,
            getTableProps(pagination, filters, sorter)
        );
    };

    renderAction = action => this.props.i18n.t(`integrations.logs.actions.${action}`)

    get pagination() {
        return getPagination(this.props.pagination);
    }

    render() {
        const { isLoading, logs } = this.props;
        return (
            <div>
                <Core.Table
                    columns={this.tableColumns}
                    data={logs}
                    isLoading={isLoading}
                    pagination={this.pagination}
                    onChange={this.onChangeTable}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    logs: selectors.getIntegrationLogs(state, ownProps.integrationId),
    pagination: selectors.getIntegrationLogsPagination(state, ownProps.integrationId),
    isLoading: selectors.isLoadingIntegrationLogs(state, ownProps.integrationId)
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(translate()(IntegrationLogs));